import { FieldMessage } from 'braid-design-system';
import React from 'react';

import type { CreditCardFormValidationError } from '../../../../usecases/CreditCard/creditcardTypes';

interface ValidationMesasgeProp {
  message: string | null;
  field: CreditCardFormValidationError;
}

const ValidationMesasge = ({ message, field }: ValidationMesasgeProp) => {
  if (message) {
    return (
      <FieldMessage id={`msg-${field}`} message={message} tone="critical" />
    );
  }
  // add empty space to avoid layout shift
  return <FieldMessage id={`msg-${field}`} message="" tone="neutral" />;
};

export default ValidationMesasge;
